const workData = [
  {
    id: "1",
    iconImg: "icon-img",
    quotation: "Lorem ipsum dolor sit amet.",
    shortNote: "Lorem ipsum dolor sit amet consectetur.",
  },
  {
    id: "2",
    iconImg: "icon-img",
    quotation: "Lorem ipsum dolor sit amet.",
    shortNote: "Lorem ipsum dolor sit amet consectetur.",
  },
  {
    id: "3",
    iconImg: "icon-img",
    quotation: "Lorem ipsum dolor sit amet.",
    shortNote: "Lorem ipsum dolor sit amet consectetur.",
  },
  {
    id: "4",
    iconImg: "icon-img",
    quotation: "Lorem ipsum dolor sit amet.",
    shortNote: "Lorem ipsum dolor sit amet consectetur.",
  },
];

export default workData;
